/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */

import React, { useState } from 'react';
import {
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  Marker,
  InfoWindow,
} from 'react-google-maps';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import HotelCardV2 from './HotelCardV2';
import { GOOGLE_MAP_KEY } from '../../../saas/AppStorageStaticNames';

const MapComponent = withScriptjs(
  withGoogleMap(
    ({
      locations,
      selectedLocation,
      onSelectLocation,
      onRoomChoose,
      showInvoiceFare,
      currencyOption,
      conversionRate,
      onShortList,
      intl,
      shortListedHotels,
    }) => (
      <GoogleMap
        defaultZoom={10}
        defaultCenter={{
          lat: Number(locations[0].lat),
          lng: Number(locations[0].lng),
        }}
      >
        {locations.map((location, index) => (
          <Marker
            key={index}
            position={{ lat: Number(location.lat), lng: Number(location.lng) }}
            onClick={() => onSelectLocation(location)}
            title={location.hn}
            // icon="/images/others/arrow-down.png"
            labelAnchor={new window.google.maps.Point(20, 45)}
            labelStyle={{
              color: '#fff',
              backgroundColor: '#222',
              fontSize: '12px',
              padding: '4px',
            }}
            labelContent={location.propertyName}
          >
            {selectedLocation === location && (
              <InfoWindow
                onCloseClick={() => onSelectLocation(null)}
                className="hotel-map-view_info-window"
              >
                <HotelCardV2
                  intl={intl}
                  hotelData={location}
                  onRoomChoose={onRoomChoose}
                  showInvoiceFare={showInvoiceFare}
                  currencyOption={currencyOption}
                  conversionRate={conversionRate}
                  onShortList={onShortList}
                  shortListedHotels={shortListedHotels}
                />
              </InfoWindow>
            )}
          </Marker>
        ))}
      </GoogleMap>
    ),
  ),
);

function HotelMapOldView({
  hotelDetails,
  onRoomChoose,
  showInvoiceFare,
  currencyOption,
  conversionRate,
  onShortList,
  shortListedHotels,
}) {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const intl = useIntl();

  const handleSelectLocation = (location) => {
    setSelectedLocation(location);
  };

  return (
    <div
      style={{ height: '520px', position: 'relative' }}
      className="hotel-map-view"
    >
      <MapComponent
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_KEY}&v=3.exp&libraries=geometry,drawing,places`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: '500px' }} />}
        mapElement={<div style={{ height: '500px' }} />}
        locations={hotelDetails}
        selectedLocation={selectedLocation}
        onSelectLocation={handleSelectLocation}
        onRoomChoose={onRoomChoose}
        showInvoiceFare={showInvoiceFare}
        currencyOption={currencyOption}
        conversionRate={conversionRate}
        onShortList={onShortList}
        shortListedHotels={shortListedHotels}
        className="hotel-map-view_container"
        intl={intl}
      />
    </div>
  );
}

HotelMapOldView.propTypes = {
  hotelDetails: PropTypes.array.isRequired,
  onRoomChoose: PropTypes.func.isRequired,
  onShortList: PropTypes.func.isRequired,
  showInvoiceFare: PropTypes.bool.isRequired,
  currencyOption: PropTypes.any.isRequired,
  conversionRate: PropTypes.any.isRequired,
  shortListedHotels: PropTypes.array.isRequired,
};

export default HotelMapOldView;
